export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */

    $(document).ready(function(){


        // Google Map on locations
        (function($) {

          /**
           * centerMap
           *
           * Centers the map showing all markers in view.
           *
           * @date    22/10/19
           * @since   5.8.6
           *
           * @param   object The map instance.
           * @return  void
           */
          function centerMap( map ) {

              // Create map boundaries from all map markers.
              var bounds = new google.maps.LatLngBounds();
              map.markers.forEach(function( marker ){
                  bounds.extend({
                      lat: marker.position.lat(),
                      lng: marker.position.lng()
                  });
              });

              // Case: Single marker.
              if( map.markers.length === 1 ){


                  //map.setCenter( bounds.getCenter() );
                  // get the current center
                  var theCenter = bounds.getCenter();
                  
                  // set center of map
                map.setCenter( {lat: theCenter.lat(), lng: theCenter.lng() + -0.0015} );
                map.setZoom( 18 );


              // Case: Multiple markers.
              } else{
                  map.fitBounds( bounds );
              }
          }




          /**
           * initMap
           *
           * Renders a Google Map onto the selected jQuery element
           *
           * @date    22/10/19
           * @since   5.8.6
           *
           * @param   jQuery $el The jQuery element.
           * @return  object The map instance.
           */
          function initMap( $el ) {

              // Find marker elements within map.
              var $markers = $el.find('.marker');

              // Create gerenic map.
              var mapArgs = {
                  zoom        : $el.data('zoom') || 18,
                  mapTypeId   : google.maps.MapTypeId.ROADMAP,
                  styles : [
                            {
                                "featureType": "all",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "saturation": 36
                                    },
                                    {
                                        "color": "#333333"
                                    },
                                    {
                                        "lightness": 40
                                    }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 16
                                    }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#fefefe"
                                    },
                                    {
                                        "lightness": 20
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#fefefe"
                                    },
                                    {
                                        "lightness": 17
                                    },
                                    {
                                        "weight": 1.2
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 20
                                    },
                                    {
                                        "color": "#ececec"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape.man_made",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#f0f0ef"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape.man_made",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "visibility": "simplified"
                                    },
                                    {
                                        "saturation": "17"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape.man_made",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#d4d4d4"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape.natural",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#ececec"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape.natural",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "lightness": "20"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 21
                                    },
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#d4d4d4"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "visibility": "simplified"
                                    },
                                    {
                                        "weight": "2.26"
                                    },
                                    {
                                        "lightness": "-50"
                                    },
                                    {
                                        "saturation": "-100"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#303030"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "saturation": "-100"
                                    },
                                    {
                                        "lightness": "50"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.attraction",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.business",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.government",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.medical",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#dedede"
                                    },
                                    {
                                        "lightness": 21
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.place_of_worship",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.school",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.school",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "lightness": "-61"
                                    },
                                    {
                                        "gamma": "0.00"
                                    },
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.sports_complex",
                                "elementType": "all",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 17
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 29
                                    },
                                    {
                                        "weight": 0.2
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 18
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 16
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#f2f2f2"
                                    },
                                    {
                                        "lightness": 19
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#dadada"
                                    },
                                    {
                                        "lightness": 17
                                    }
                                ]
                            }
                        ]
              };
              var map = new google.maps.Map( $el[0], mapArgs );

              // Add markers.
              map.markers = [];
              $markers.each(function(){
                  initMarker( $(this), map );
              });

              // Center map based on markers.
              centerMap( map );

              // listen for the window resize event & trigger Google Maps to update too
              $(window).resize(function() {
                // (the 'map' here is the result of the created 'var map = ...' above)
                google.maps.event.trigger(map, "resize");
              });

              // Return map instance.
              return map;
          }
          /**
           * initMarker
           *
           * Creates a marker for the given jQuery element and map.
           *
           * @date    22/10/19
           * @since   5.8.6
           *
           * @param   jQuery $el The jQuery element.
           * @param   object The map instance.
           * @return  object The marker instance.
           */
          function initMarker( $marker, map ) {

              // Get position from marker.
              var lat = $marker.data('lat');
              var lng = $marker.data('lng');
              var latLng = {
                  lat: parseFloat( lat ),
                  lng: parseFloat( lng )
              };

              // var icon = {
              //     path: "M34.5,0A34.5,34.5,0,0,1,69,34.5c0,19.054-17.97,43.7-34.5,56.085C17.694,79.355,0,53.554,0,34.5A34.5,34.5,0,0,1,34.5,0Z",
              //     fillColor: '#24C26A',
              //     fillOpacity: 1,
              //     anchor: new google.maps.Point(16,45),
              //     strokeWeight: 0,
              //     scale: 1
              // };

              // default marker img
              var icon = {
                    url: "/wp-content/themes/optimal-solicitors/dist/images/map-marker.svg",
                    anchor: new google.maps.Point(35,90),
                    scaledSize: new google.maps.Size(69,90),
                    //anchor: { x: 15, y: 15 },
                }

              // create a marker with our custom icon
              var marker = new google.maps.Marker({
                position: latLng,
                map: map,
                // icon: '/app/themes/burnleyleisure/map-markers/map-marker.svg',
                icon: icon,
                size: new google.maps.Size(69,90),
              });

              // Append to reference for later use.
              map.markers.push( marker );

              // If marker contains HTML, add it to an infoWindow.
              if( $marker.html() ){

                  // Create info window.
                  var infowindow = new google.maps.InfoWindow({
                      content: $marker.html()
                  });

                  // Show info window when marker is clicked.
                  google.maps.event.addListener(marker, 'click', function() {
                      infowindow.open( map, marker );
                  });
              }
          }

          // Render the map on page load
          $(document).ready(function(){
              $('.acf-map').each(function(){
                  var map = initMap( $(this) );
              });
          });          


        })(jQuery);



    });

    /* eslint-enable */

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/contact.js